import { Box, Button, Flex } from '@chakra-ui/react'
import {
  ContentNotFound,
  FullScreenSliderSection,
  Hero,
  Layout,
  LearnWithSsm,
  RelatedEvents,
  StickyHeader,
} from '@common'
import { ISSRPageData } from '@interfaces'
import { PageService } from '@services'
import { checkStickyNavItem, createNavLink, getStickyId } from '@utils'
import useTranslation from 'next-translate/useTranslation'
import { useRouter } from 'next/router'
// import DISCOVER_SLIDER_CONTENT from '@lib/const/discover-slider-content-art-for-all.const'
// import EXPLORE_ART_FOR_ALL_NAV from '@lib/const/explore-art-for-all-nav.const'
// import LEARN_WITH_SSM_SLIDER_CONTENT from '@lib/const/learn-with-ssm-slider.const'
// import RELATED_ART_FOR_ALL_COLLECTIONS from '@lib/const/related-art-for-all-collection.const'

const ArtForAllScreen = ({
  pageData,
  global: { navigation },
}: ISSRPageData) => {
  const { t } = useTranslation()
  const router = useRouter()

  const handleInspringExploreAll = () =>
    router.push(createNavLink('newsAndBlog', router.locale))

  if (pageData.error) {
    return (
      <Layout
        title={t('explore-art:artForAll.pageTitle')}
        navigation={navigation}
        path={router.asPath}
      >
        <ContentNotFound />
      </Layout>
    )
  }

  return (
    <Layout
      title={t('explore-art:artForAll.pageTitle')}
      navigation={navigation}
      path={router.asPath}
    >
      <Hero
        bgImageUrl={
          pageData.data.hero.bgImageUrl !== ''
            ? pageData.data.hero.bgImageUrl
            : '/img/explore-art/art-for-all/banner/banner-bg.jpg'
        }
        subTitle={pageData.data.hero.subTitle}
        title={pageData.data.hero.title}
        description={pageData.data.hero.description}
      />
      <Box as="main" pt={4}>
        <StickyHeader navs={pageData.data.stickyNavItems} />
        {checkStickyNavItem(pageData.data.stickyNavItems, 'stayUpdated') && (
          <FullScreenSliderSection
            stickyId={getStickyId(pageData.data.stickyNavItems, 'stayUpdated')}
            subTitle={t('explore-art:discoverArt.subTitle')}
            title={t('explore-art:discoverArt.title')}
            description={t('explore-art:discoverArt.description')}
            sliderCollection={pageData.data.stayUpdated.slider}
            viewAllButtonLabelTx={t('explore-art:discoverArt.buttonLabel')}
            viewAllButtonLabelOnClick={handleInspringExploreAll}
            customHTMLContent={pageData.data.stayUpdated.bannerTextContent}
            isCustomTextContent={true}
          />
        )}

        {checkStickyNavItem(pageData.data.stickyNavItems, 'getInspired') && (
          <RelatedEvents
            containerProps={{
              pt: {
                base: 'padding.primary2',
                lg: 'padding.primary4',
              },
            }}
            stickyId={getStickyId(pageData.data.stickyNavItems, 'getInspired')}
            title={t('explore-art:relatedInspiring.title')}
            collection={pageData.data.inspiringArticles}
            primaryColor="blue"
            mainType="Article"
          >
            <Flex justifyContent="center" mt="padding.primary">
              <Button
                onClick={handleInspringExploreAll}
                height="100px"
                width={{ base: 'full', lg: '240px' }}
                bgColor={'blue.primary'}
                _hover={{
                  bgColor: 'blue.primary2',
                }}
              >
                {t('explore-art:discoverArt.buttonLabel')}
              </Button>
            </Flex>
          </RelatedEvents>
        )}
        {checkStickyNavItem(pageData.data.stickyNavItems, 'learnWitSSM') && (
          <LearnWithSsm
            stickyId={getStickyId(pageData.data.stickyNavItems, 'learnWitSSM')}
            subTitle={t('explore-art:learnWithSsm.subTitle')}
            title={t('explore-art:learnWithSsm.title')}
            description={t('explore-art:learnWithSsm.description')}
            discoverCardCollection={pageData.data?.learnWithSSM}
          />
        )}
      </Box>
    </Layout>
  )
}

export default ArtForAllScreen

export async function getStaticProps({ locale }) {
  const pageData = {
    data: null,
    error: null,
  }

  try {
    const artForAllData = await PageService.getDataArtForAllPage(locale)

    pageData.data = artForAllData
  } catch (err) {
    if (err instanceof Error) {
      pageData.error = { message: err.message }
    }
  }

  return {
    props: { pageData },
  }
}
